import { render, staticRenderFns } from "./stockAddOrUpdate.vue?vue&type=template&id=aa34c9c2&scoped=true&"
import script from "./stockAddOrUpdate.vue?vue&type=script&lang=js&"
export * from "./stockAddOrUpdate.vue?vue&type=script&lang=js&"
import style0 from "./stockAddOrUpdate.vue?vue&type=style&index=0&id=aa34c9c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa34c9c2",
  null
  
)

export default component.exports